import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';

import CheckBox from '../common/inputs/checkBox';
import Spinner from '../common/interface/spinner';

class TemplateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closedItems: {}
    };
  }

  handleOpenClose = (event) => {
    let elementId = event.currentTarget.dataset.elementid;
    if(elementId in this.state.closedItems) {
      delete this.state.closedItems[elementId];
    }
    else {
      this.state.closedItems[elementId] = true;
    }
    this.setState({
      closedItems: this.state.closedItems
    });
  };
  
  getNodeRows = (node, handleOpenClose, paddingTree = 0) => {
    let nodeRows = [];
    if(node) {
      let has_childs = (node.childs && node.childs.length>0) ? true : false;
      let is_open = (has_childs && !(node.element_id in this.state.closedItems)) ? true : false;
      nodeRows.push((
        <div 
          key={node.element_id}
          className={"free-text-list-list-item"}
        >
          <div             
            onClick={has_childs ? handleOpenClose : null} 
            data-elementid={node.element_id}
            title={node.formula_call}
            className={"free-text-list-list-item-inner" + (!has_childs ? " non_clickable" : "")} style={{paddingLeft: (paddingTree + "px")}}>
            {has_childs && (
              <i 
                data-id={node.element_id}
                className={"fas fa-" + (is_open ? "minus-square" : "plus-square")}
              />
            )}
            {!node.is_report_detail ? 
              intl.formatMessage({ id: "biTemplateAdmin.fields.tree_" + node.formula_type + "_abbrv"}) + ": " + node.label : 
              (!node.is_report_detail_total ? 
                intl.formatMessage({ id: "biTemplateAdmin.fields.tree_detail_abbrv"}) + ": " + node.label :
                node.label)}
          </div>
          <CheckBox 
            data-templateeditor={"true"}
            value={node.display_report}
            data-path={node.element_id}
            onChange={this.props.onChange}
          />
        </div>
      ));
      if(node.childs && is_open) {
        node.childs.forEach(childNode => {
          nodeRows = nodeRows.concat(this.getNodeRows(childNode, handleOpenClose, paddingTree+15));
        });
      }
    }
    return nodeRows;
  };

  render() {
    const {
      modelName,
      generateLoading,
      polynomialTree,
      onChange
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list select-list template-editor select-list-no-search" }>
        <div className="free-text-list-label">
          <FormattedMessage id="biTemplateAdmin.fields.polynomial_tree"/>{": "}
          {modelName ? modelName : intl.formatMessage({ id: "biTemplateAdmin.fields.generate_pending"})}
        </div>
        {(generateLoading) ? (
          <div className="free-text-list-list-wrapper free-text-list-list-wrapper-loading">
            <Spinner/>
          </div>
        ) : (
          <div className="free-text-list-list-wrapper">
            {this.getNodeRows(polynomialTree, this.handleOpenClose)}
          </div>
        )}
      </div>
    );
  }
}
          
export default TemplateEditor;
              


// WEBPACK FOOTER //
// ./source/client/components/biTemplateAdmin/templateEditor.jsx